"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DALError = DALError;
exports.statusToErrorClass = exports.DALGatewayTimeoutError = exports.DALServiceUnavailableError = exports.DALBadGatewayError = exports.DALNoErrorError = exports.DALNoDataError = exports.DALJsonParseError = exports.DALServerError = exports.DALUnauthorizedError = exports.DALForbiddenError = exports.DALBadRequestError = exports.DALNotFoundError = exports.DALNetworkTimeoutError = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf14 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

function DALError(message, details) {
  var _this = this;

  var extras = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  this.isDalError = true;
  this.message = message;
  this.details = details;
  this.name = 'DALError';
  Object.keys(extras).forEach(function (key) {
    _this[key] = extras[key];
  });
  var err = Error(message);
  this.stack = err.stack;
}

DALError.prototype = Object.create(Error.prototype);
DALError.prototype.constructor = DALError;

var DALNetworkTimeoutError =
/*#__PURE__*/
function (_DALError) {
  (0, _inherits2["default"])(DALNetworkTimeoutError, _DALError);

  function DALNetworkTimeoutError() {
    var _getPrototypeOf2;

    var _this2;

    (0, _classCallCheck2["default"])(this, DALNetworkTimeoutError);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf14["default"])(DALNetworkTimeoutError)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this2.name = 'DALNetworkTimeoutError';
    return _this2;
  }

  return DALNetworkTimeoutError;
}(DALError);

exports.DALNetworkTimeoutError = DALNetworkTimeoutError;

var DALNotFoundError =
/*#__PURE__*/
function (_DALError2) {
  (0, _inherits2["default"])(DALNotFoundError, _DALError2);

  function DALNotFoundError() {
    var _getPrototypeOf3;

    var _this3;

    (0, _classCallCheck2["default"])(this, DALNotFoundError);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf3 = (0, _getPrototypeOf14["default"])(DALNotFoundError)).call.apply(_getPrototypeOf3, [this].concat(args)));
    _this3.name = 'DALNotFoundError';
    return _this3;
  }

  return DALNotFoundError;
}(DALError);

exports.DALNotFoundError = DALNotFoundError;

var DALBadRequestError =
/*#__PURE__*/
function (_DALError3) {
  (0, _inherits2["default"])(DALBadRequestError, _DALError3);

  function DALBadRequestError() {
    var _getPrototypeOf4;

    var _this4;

    (0, _classCallCheck2["default"])(this, DALBadRequestError);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this4 = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf4 = (0, _getPrototypeOf14["default"])(DALBadRequestError)).call.apply(_getPrototypeOf4, [this].concat(args)));
    _this4.name = 'DALBadRequestError';
    return _this4;
  }

  return DALBadRequestError;
}(DALError);

exports.DALBadRequestError = DALBadRequestError;

var DALForbiddenError =
/*#__PURE__*/
function (_DALError4) {
  (0, _inherits2["default"])(DALForbiddenError, _DALError4);

  function DALForbiddenError() {
    var _getPrototypeOf5;

    var _this5;

    (0, _classCallCheck2["default"])(this, DALForbiddenError);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this5 = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf5 = (0, _getPrototypeOf14["default"])(DALForbiddenError)).call.apply(_getPrototypeOf5, [this].concat(args)));
    _this5.name = 'DALForbiddenError';
    return _this5;
  }

  return DALForbiddenError;
}(DALError);

exports.DALForbiddenError = DALForbiddenError;

var DALUnauthorizedError =
/*#__PURE__*/
function (_DALError5) {
  (0, _inherits2["default"])(DALUnauthorizedError, _DALError5);

  function DALUnauthorizedError() {
    var _getPrototypeOf6;

    var _this6;

    (0, _classCallCheck2["default"])(this, DALUnauthorizedError);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this6 = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf6 = (0, _getPrototypeOf14["default"])(DALUnauthorizedError)).call.apply(_getPrototypeOf6, [this].concat(args)));
    _this6.name = 'DALUnauthorizedError';
    return _this6;
  }

  return DALUnauthorizedError;
}(DALError);

exports.DALUnauthorizedError = DALUnauthorizedError;

var DALServerError =
/*#__PURE__*/
function (_DALError6) {
  (0, _inherits2["default"])(DALServerError, _DALError6);

  function DALServerError() {
    var _getPrototypeOf7;

    var _this7;

    (0, _classCallCheck2["default"])(this, DALServerError);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this7 = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf7 = (0, _getPrototypeOf14["default"])(DALServerError)).call.apply(_getPrototypeOf7, [this].concat(args)));
    _this7.name = 'DALServerError';
    return _this7;
  }

  return DALServerError;
}(DALError);

exports.DALServerError = DALServerError;

var DALJsonParseError =
/*#__PURE__*/
function (_DALError7) {
  (0, _inherits2["default"])(DALJsonParseError, _DALError7);

  function DALJsonParseError() {
    var _getPrototypeOf8;

    var _this8;

    (0, _classCallCheck2["default"])(this, DALJsonParseError);

    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    _this8 = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf8 = (0, _getPrototypeOf14["default"])(DALJsonParseError)).call.apply(_getPrototypeOf8, [this].concat(args)));
    _this8.name = 'DALJsonParseError';
    return _this8;
  }

  return DALJsonParseError;
}(DALError);

exports.DALJsonParseError = DALJsonParseError;

var DALNoDataError =
/*#__PURE__*/
function (_DALError8) {
  (0, _inherits2["default"])(DALNoDataError, _DALError8);

  function DALNoDataError() {
    var _getPrototypeOf9;

    var _this9;

    (0, _classCallCheck2["default"])(this, DALNoDataError);

    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    _this9 = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf9 = (0, _getPrototypeOf14["default"])(DALNoDataError)).call.apply(_getPrototypeOf9, [this].concat(args)));
    _this9.name = 'DALNoDataError';
    return _this9;
  }

  return DALNoDataError;
}(DALError);

exports.DALNoDataError = DALNoDataError;

var DALNoErrorError =
/*#__PURE__*/
function (_DALError9) {
  (0, _inherits2["default"])(DALNoErrorError, _DALError9);

  function DALNoErrorError() {
    var _getPrototypeOf10;

    var _this10;

    (0, _classCallCheck2["default"])(this, DALNoErrorError);

    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }

    _this10 = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf10 = (0, _getPrototypeOf14["default"])(DALNoErrorError)).call.apply(_getPrototypeOf10, [this].concat(args)));
    _this10.name = 'DALNoErrorError';
    return _this10;
  }

  return DALNoErrorError;
}(DALError);

exports.DALNoErrorError = DALNoErrorError;

var DALBadGatewayError =
/*#__PURE__*/
function (_DALError10) {
  (0, _inherits2["default"])(DALBadGatewayError, _DALError10);

  function DALBadGatewayError() {
    var _getPrototypeOf11;

    var _this11;

    (0, _classCallCheck2["default"])(this, DALBadGatewayError);

    for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      args[_key10] = arguments[_key10];
    }

    _this11 = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf11 = (0, _getPrototypeOf14["default"])(DALBadGatewayError)).call.apply(_getPrototypeOf11, [this].concat(args)));
    _this11.name = 'DALBadGatewayError';
    return _this11;
  }

  return DALBadGatewayError;
}(DALError);

exports.DALBadGatewayError = DALBadGatewayError;

var DALServiceUnavailableError =
/*#__PURE__*/
function (_DALError11) {
  (0, _inherits2["default"])(DALServiceUnavailableError, _DALError11);

  function DALServiceUnavailableError() {
    var _getPrototypeOf12;

    var _this12;

    (0, _classCallCheck2["default"])(this, DALServiceUnavailableError);

    for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      args[_key11] = arguments[_key11];
    }

    _this12 = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf12 = (0, _getPrototypeOf14["default"])(DALServiceUnavailableError)).call.apply(_getPrototypeOf12, [this].concat(args)));
    _this12.name = 'DALServiceUnavailableError';
    return _this12;
  }

  return DALServiceUnavailableError;
}(DALError);

exports.DALServiceUnavailableError = DALServiceUnavailableError;

var DALGatewayTimeoutError =
/*#__PURE__*/
function (_DALError12) {
  (0, _inherits2["default"])(DALGatewayTimeoutError, _DALError12);

  function DALGatewayTimeoutError() {
    var _getPrototypeOf13;

    var _this13;

    (0, _classCallCheck2["default"])(this, DALGatewayTimeoutError);

    for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      args[_key12] = arguments[_key12];
    }

    _this13 = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf13 = (0, _getPrototypeOf14["default"])(DALGatewayTimeoutError)).call.apply(_getPrototypeOf13, [this].concat(args)));
    _this13.name = 'DALGatewayTimeoutError';
    return _this13;
  }

  return DALGatewayTimeoutError;
}(DALError);

exports.DALGatewayTimeoutError = DALGatewayTimeoutError;

var statusToErrorClass = function statusToErrorClass(status) {
  var defaultType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DALError;
  return {
    400: DALBadRequestError,
    401: DALUnauthorizedError,
    403: DALForbiddenError,
    404: DALNotFoundError,
    500: DALServerError,
    502: DALBadGatewayError,
    503: DALServiceUnavailableError,
    504: DALGatewayTimeoutError
  }[status] || defaultType;
};

exports.statusToErrorClass = statusToErrorClass;